export const LOGIN_SUCCESS="LOGIN_SUCCESS";
export const LOGOUT_SUCCESS="LOGOUT_SUCCESS";